import { useState } from 'react';
import Back from 'components/Back';
import {
  Button,
  Card, Container, Radios,
} from 'nhsuk-react-components';
import { useNavigate, useParams } from 'react-router-dom';
import useFetchTeamMembers from 'queries/fetch/fetchTeamMembers.ts';
import { ITeamLevelParams } from 'utils/parameterUtils.ts';
import useFetchTeamDetails from 'queries/fetch/fetchTeamDetails.ts';
import ProgressIndicator from 'components/ProgressIndicator';

function SelectUserPage() {
  const { teamId } = useParams() as ITeamLevelParams;
  const teamMembers = useFetchTeamMembers();
  const teamDetails = useFetchTeamDetails({ teamId });
  const [selectedUser, setSelectedUser] = useState<string>('');
  const navigate = useNavigate();

  if (!teamMembers.data || !teamDetails.data) {
    return <ProgressIndicator />;
  }

  const teamUsers = Object
    .entries(teamMembers.data)
    .filter(([team]) => team === teamId)
    .map(([_, rolesToUsers]) => Object.values(rolesToUsers)).flat(2)
    .filter((user, index, users) => index === users.findIndex((u) => u.sub === user.sub));

  return (
    <Container>
      <div className="nhsuk-u-margin-top-6 nhsuk-u-margin-bottom-6">
        <Back />
      </div>
      <Card>
        <Radios
          legend={`Choose a user for ${teamDetails.data.team.TEAM_NAME}`}
          legendProps={{ isPageHeading: true, size: 'm' }}
          onChange={(formEvent) => {
            setSelectedUser((formEvent.target as HTMLInputElement).value);
          }}
        >
          {teamUsers
            .toSorted((a, b) => (a.given_name ?? a.name ?? a.Username).localeCompare(b.given_name ?? b.name ?? b.Username))
            .map((user) => (
              <Radios.Item value={user.sub} key={user.sub}>
                {
                  user.given_name
                    ? `${user.given_name} ${user.family_name}`
                    : user.name ?? user.Username
                }
              </Radios.Item>
            ))}
        </Radios>
      </Card>

      <Button
        onClick={() => {
          navigate(`/admin/${teamId}/manage-user-details/user/${selectedUser}`);
        }}
      >
        Save and continue
      </Button>
    </Container>
  );
}

export default SelectUserPage;
